export default __webpack_public_path__ + "static/The Home_Image 4_carousel 5@2x-db22011430c97cc4daf8712db9e81045.jpg";